import {inject} from '@angular/core';
import {CanActivateFn, UrlTree} from '@angular/router';
import {AuthService} from '../auth';
import {Observable, of} from 'rxjs';

export const redirectGuard: CanActivateFn = (
    route,
    state
): Observable<boolean | UrlTree> => {
    const authService = inject(AuthService);

    const redirectedUrl = state.url;
    const [path, query] = redirectedUrl.split('?');

    if (path === '/opportunity-context' || path === '/view-quote' || path === '/duplicate-quote') {
        authService.storeRedirectedUrl(redirectedUrl);
    }
    return of(true);
};
